// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lunbo":"lunbo-2ErKCBJf","dotCurrent":"dotCurrent-Cwqzhz0g","box":"box-28t9jL_-","image":"image-m3SWQHew","link":"link-FV-bMkZO"};